const candidatesSettingsLinks: any[] = [
  {
    label: "CANDIDATES_SOURCES",
    capability: "show_menu_candidate_source",
    url: "/dashboard/candidate-source",
    section: "lists", // lists, update_data, administration, documents, notifications, manage_platform, user_permissions
  },
  {
    label: "MENU.RATING_CANDIDATE",
    capability: "show_menu_candidate_ratings_list",
    url: "/dashboard/candidate-ratings",
    section: "lists", // lists, update_data, administration, documents, notifications, manage_platform, user_permissions
  },
];
export default candidatesSettingsLinks;
